import { render, staticRenderFns } from "./MontosTooltip.vue?vue&type=template&id=65fd6e2b&"
import script from "./MontosTooltip.vue?vue&type=script&lang=js&"
export * from "./MontosTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports